<template>
  <div class="container">
    <m-single-post-501 :flat-categories-shape="true" />
  </div>
</template>

<script>

export default {
  name: "SingleCourse",
}
</script>

<style>
.category-custom-z-index{
  position: relative !important;
}
</style>

<style scoped>

</style>